// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iframe-container {
  width: 100%;
  height: 100vh; /* full viewport height */
}

.full-iframe {
  width: 100%;
  height: 100%;
  border: none;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/common/report/report-shareable-link.component.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa,EAAE,yBAAyB;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd","sourcesContent":[".iframe-container {\n  width: 100%;\n  height: 100vh; /* full viewport height */\n}\n\n.full-iframe {\n  width: 100%;\n  height: 100%;\n  border: none;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
